/**
 * Which gate buttons to show, from what the gate status says.
 *
 * Close always releases any hold before closing, so it is the one button that works on a held gate. A gate
 * that is held open shows Close as the primary action and hides Open and Hold open, which cannot release it.
 * When the status is unknown (not supported, still loading, failing) every button stays, in its normal style.
 */
export interface GateActions {
  open: boolean;
  close: boolean;
  /** "Hold gate open". */
  holdOpen: boolean;
  /** Close is the filled button while the gate is held. */
  closeVariant: "primary" | "default";
}

export function getGateActions({ isHeld }: { isHeld: boolean }): GateActions {
  return {
    open: !isHeld,
    close: true,
    holdOpen: !isHeld,
    closeVariant: isHeld ? "primary" : "default",
  };
}
